
import { useTranslation } from 'react-i18next';

type Props = {
    children: any
}

export default function Translatable({ children }: Props) {
  const { t } = useTranslation();

  return (
    <>
      {t(`${ children }`)}
    </>
  )
}
